import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import Close from '~/shared/assets/icons/Close'
import Button from '~/shared/components/buttons/Button'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function CircleApplyDeletedModal() {
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() =>
          setIsModalOpen({ ...isModalOpen, contents: '', isOpen: false })
        }
      />
      <MainText>취소 신청이 완료되었습니다.</MainText>

      <ButtonBox>
        <Button
          $width={194}
          $height={58}
          $fontSize={24}
          $variant="transparent"
          onClick={() => {
            setIsModalOpen({ ...isModalOpen, contents: '', isOpen: false })
            navigate('/circle-participation/apply')
          }}
        >
          참가 신청 메뉴로 이동
        </Button>
        <Button
          $width={194}
          $height={58}
          $fontSize={24}
          $variant="transparent"
          onClick={() => {
            setIsModalOpen({ ...isModalOpen, contents: '', isOpen: false })
            navigate('/')
          }}
        >
          홈으로 이동
        </Button>
      </ButtonBox>
    </Wrapper>
  )
}

export default CircleApplyDeletedModal

const Wrapper = styled.section`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  min-width: 30%;
  height: auto;
  margin: 0 auto;
  padding: 108px 60px 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 90%;
    height: 80%;
    padding: 56px 20px 30px;
  }
`

const CloseIcon = styled(Close)`
  cursor: pointer;
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const MainText = styled.h1`
  width: ${theme.calculatePcVw(580)};

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 58px;
  text-align: center;

  @media ${theme.device.medium} {
    width: 80%;
    height: 100px;

    font-size: 36px;
    font-weight: 500;
    line-height: 140%;
  }
`

const ButtonBox = styled.div`
  display: flex;
  gap: 20px;
  width: 580px;

  > :nth-child(1) {
    width: 100%;
    color: ${theme.colors.white};
    background-color: ${theme.colors.black};
  }

  > :nth-child(2) {
    width: 100%;
    color: ${theme.colors.black};
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.black};
  }

  @media ${theme.device.medium} {
    flex-direction: column;

    > :nth-child(1) {
      width: 50%;
      margin: 0 auto;
    }

    > :nth-child(2) {
      width: 50%;
      margin: 0 auto;
    }
  }
`
